import { Box, Stack, Typography } from "@mui/material";

interface Props {
  label: string;
  topText: string;
  textColor: string;
}

const SuccessFigures = ({ label, topText, textColor }: Props) => {
  return (
    <Box
      //   border={"1px solid blue"}
      display={"flex"}
    >
      <Stack justifyContent={"center"} alignItems={"center"}>
        <Typography
          fontWeight={700}
          fontSize={{ md: "36px", sm: "36px", xs: 26 }}
          color={textColor}
        >
          {" "}
          {topText}
        </Typography>
        <Typography
          width={"169px"}
          fontWeight={400}
          fontSize={{ md: "12px", sm: "12px", xs: "9px" }}
          color={"#868686"}
          textAlign={"center"}
        >
          {" "}
          {label}
        </Typography>
      </Stack>
    </Box>
  );
};

export default SuccessFigures;
